import Reveal from "../components/Reveal";
import { DINING } from "../data/content";

export default function Dining() {
  return (
    <section data-testid="dining-section" className="mx-auto max-w-7xl px-6 py-24 sm:px-12 sm:py-32 lg:px-20 lg:py-40">
      <Reveal>
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-brass">Bush Dining</p>
      </Reveal>
      <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
        <Reveal delay={0.1}>
          <h2 className="font-serif text-3xl font-light leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
            Eat with <span className="italic text-brass">the wild.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="max-w-md text-sm leading-relaxed text-ivory/60">
            Food here is mostly grown in and around the lodge, and served fresh — often
            outdoors, always unhurried.
          </p>
        </Reveal>
      </div>
      <div className="mt-14">
        {DINING.map((d, i) => (
          <Reveal key={d.title} delay={i * 0.08}>
            <div
              data-testid={`dining-item-${i}`}
              className="group flex flex-wrap items-baseline justify-between gap-3 border-t border-ivory/10 py-7 transition-colors duration-500 last:border-b hover:border-brass/40"
            >
              <div className="flex items-baseline gap-6">
                <span className="font-serif text-sm italic text-brass/70">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-serif text-2xl font-light text-ivory transition-colors duration-500 group-hover:text-brass sm:text-3xl">
                  {d.title}
                </h3>
              </div>
              <p className="max-w-sm text-sm leading-relaxed text-ivory/55">{d.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
